export const SoundsOnSVG = (props) => (
  <svg
    width="800px"
    height="800px"
    viewBox="0 0 28 28"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <path
      clipRule="evenodd"
      d="M6.48542 18.6893L13.0821 25.1703C14.8862 26.9427 17.971 25.6874 17.971 23.1808V4.81925C17.971 2.3126 14.8862 1.05725 13.0821 2.82973L6.48542 9.31065H3.43958C2.09223 9.31065 1 10.3837 1 11.7074V16.2926C1 17.6163 2.09224 18.6893 3.43958 18.6893H6.48542ZM7.58159 16.8188L14.5821 23.6966C15.0499 24.1561 15.8496 23.8306 15.8496 23.1808V4.81925C15.8496 4.16938 15.0499 3.84392 14.5821 4.30345L7.58159 11.1812C7.44234 11.318 7.36412 11.5035 7.36412 11.697V16.303C7.36412 16.4965 7.44234 16.682 7.58159 16.8188ZM5.24275 11.3948H3.43958C3.26384 11.3948 3.12137 11.5348 3.12137 11.7074V16.2926C3.12137 16.4652 3.26384 16.6052 3.43958 16.6052H5.24275V11.3948Z"
      fill="#dcdfe1"
      fillRule="evenodd"
    />
    <path
      d="M22.7437 22.3364C22.2813 21.9831 22.2015 21.3302 22.5283 20.8526C25.3157 16.7793 25.9181 11.5645 22.7053 7.69395C22.3351 7.24793 22.3295 6.59119 22.7437 6.18423C23.158 5.77727 23.835 5.77583 24.214 6.21465C28.3909 11.0506 27.4383 17.4771 24.2055 22.1342C23.8755 22.6097 23.2061 22.6898 22.7437 22.3364Z"
      fill="#dcdfe1"
    />
    <path
      d="M20.8216 13.6463C20.7817 12.5486 20.5055 11.6062 20.1251 10.9429C19.8376 10.4415 19.7402 9.77098 20.0917 9.31056C20.4431 8.85015 21.1179 8.75448 21.4848 9.20319C22.411 10.3362 22.884 11.9871 22.9416 13.5719C23.0032 15.266 22.6045 17.1437 21.5255 18.631C21.1855 19.0996 20.5059 19.0962 20.0917 18.6893C19.6774 18.2823 19.688 17.6242 19.9906 17.1314C20.5942 16.1482 20.867 14.897 20.8216 13.6463Z"
      fill="#dcdfe1"
    />
  </svg>
)
